import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Box,
  Typography,
  Snackbar,
  Alert,
  CircularProgress,
} from "@mui/material";
import OverviewMenuButtons from "../../components/OverviewMenuButtonsWithBorder";
import BlueTile from "../../components/BlueTile";
import { ArrowForward, ArrowBack } from "@mui/icons-material";
import InputDirectoryForm from "../InvoiceAgents/InputDirectory";
import OutPutDirectory from "../InvoiceAgents/OutPutDirectory";
import FieldsDirectoryScreen from "../InvoiceAgents/FieldsDirectoryScreen";
import { useNavigate, useLocation } from "react-router-dom";
import "../../css/OverviewMenuButtonsWithBorder.css";
import AppLayout from "../../components/AppLayout";
import ReviewScreen from "../InvoiceAgents/ReviewScreen";
import OutputReview from "../InvoiceAgents/OutputReview";
import AgenName from '../../components/AgentName'
import DeployAIBot from "../../components/DeployAIBot";
import {
  createAIAgents,
  resetFormDetails,
} from "../../redux/slices/CreateAgentSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  saveFormDetails,
  resetCreateAgent,
  saveSlugName,
} from "../../redux/slices/CreateAgentSlice";
import { resetDeployAgent, saveTaskId } from "../../redux/slices/DeployAIAgent";
import { FORM_KEYS } from "../../utills/constant";
import Prompts from "./Prompts";
import CsvReviewScreen from "./CsvReviewScreen";
import { getCsvDataBySlug,updateCsvDataAction,clearSuccessMessage } from "../../redux/slices/CSVDataSlice";
import {getImages} from '../../utills/lib'; // Ensure this utility function is correctly imported

const OverviewMenuButtonsWithBorder = () => {
  const [selected, setSelected] = useState("Input");
  const [AgenNamePopUp,setAgenNamePopUp]=useState(false)
  const parentRef = useRef(null);
  const [error, setErrors] = useState({
    system_instruction: "",
    output_instruction: "",
  });
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const {csvData,updateCsvData} = useSelector((state) => state.CSVDataSlice);
  const {
    formDetails,
    createAgentLoading,
    createAgent,
    slugName,
    createAgentError,
    outputOcrFields,
  } = useSelector((state) => state.CreateAgentSlice);
  const { deployAgentLoading, deployAgentError, deployAgent } = useSelector(
    (state) => state.DeploySlice
  );
  const { profileDetails } = useSelector((state) => state.ProfileSlice);
  const receivedData = location.state;
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success", // 'success' | 'error' | 'info' | 'warning'
  });

  useEffect(()=>{
    if(receivedData?.steps){
      setSelected(receivedData?.steps)
      dispatch(getCsvDataBySlug(receivedData?.slug_id))
    }
  },[])

  useEffect(()=>{
    if(updateCsvData){
      setSnackbar({
        open: true,
        message: updateCsvData,
        severity: "success",
      });
      dispatch(getCsvDataBySlug(receivedData?.slug_id))
      dispatch(clearSuccessMessage())
    }
     
  },[updateCsvData])

    const handleUpdateDetails =()=>{
      const data ={slug:receivedData?.slug_id,params:csvData}
      dispatch(updateCsvDataAction(data))
    }
  useEffect(() => {
    dispatch(
      saveFormDetails({
        key: FORM_KEYS.ORGANIZATION_ID,
        value: profileDetails?.organization ?? 1,
      })
    );
    dispatch(saveFormDetails({ key: FORM_KEYS.IS_ACTIVE, value: true }));
    dispatch(
      saveFormDetails({ key: FORM_KEYS.IS_AVAILABLE_TO_ALL_USERS, value: true })
    );
    dispatch(
      saveFormDetails({
        key: FORM_KEYS.SYSTEM_AI_AGENT_SLUG,
        value: receivedData?.slug,
      })
    );
  }, [receivedData, profileDetails]);

  const handleCloseSnackbar = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  // Handle CreateAgent response
  useEffect(() => {
    if (!createAgentLoading && createAgent) {
      setDialogOpen(false);
      setSnackbar({
        open: true,
        message: "Agent created successfully!",
        severity: "success",
      });
      dispatch(saveSlugName(createAgent?.data?.slug));
      setSelected("Review");
      dispatch(resetCreateAgent());
    }

    if (!createAgentLoading && createAgentError) {
      setSnackbar({
        open: true,
        message: "Failed to create agent. Please try again.",
        severity: "error",
      });
    }
  }, [createAgentLoading, createAgent, createAgentError]);

  // Handle deploy AI agent response
  useEffect(() => {
    if (!deployAgentLoading && deployAgent) {
      setDialogOpen(false);
      setSnackbar({
        open: true,
        message: "Agent deployed successfully!",
        severity: "success",
      });
      dispatch(saveTaskId(deployAgent?.data?.task_id));
      dispatch(resetCreateAgent());
      dispatch(resetDeployAgent());
      dispatch(resetFormDetails());
      setTimeout(() => {
        navigate("/NewAgentViewerScreen", { state: slugName });
      }, 2000);
    }

    if (!deployAgentLoading && deployAgentError) {
      setSnackbar({
        open: true,
        message: "Failed to create agent. Please try again.",
        severity: "error",
      });
      dispatch(resetDeployAgent());
    }
  }, [deployAgentLoading, deployAgent, deployAgentError]);

  const getCsvHeaders =()=>{
    const csvHeaders = {
      Unique: "Unique identifier for the record",
      Checksum: "Checksum value for data integrity",
      Keys: "Output key used for reference",
      Description: "Details about the key",
      Format: "Expected format (e.g., string, integer, date)",
      Fields: '',
      Fields_Description: ''
     
    };
   return Object.keys(csvHeaders)
  }


  const handleCreateAgent = () => {
    setAgenNamePopUp(false)
    let updatedFormDetails = {
      ...formDetails,
      [FORM_KEYS.OCR_FIELDS]: outputOcrFields, // Fixed typo and used immutable update
    };
        updatedFormDetails['csv_headers']=[]
    if(updatedFormDetails.system_ai_agent_slug === 'moad-so' || updatedFormDetails.system_ai_agent_slug === 'extract-iq'){
      updatedFormDetails['csv_headers']=getCsvHeaders()
      updatedFormDetails[FORM_KEYS.OCR_FIELDS]=csvData
    }

    console.log('updatedFormDetails',updatedFormDetails)

    dispatch(createAIAgents(updatedFormDetails));
  };

  const [dialogOpen, setDialogOpen] = useState(false);
  const handleButtonClick = (button) => {
    console.log("button", button);
    setSelected(button);
  };

  const handleDialogOpen = () => {
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  // const getImages = () => { // Ensure field is always an object
  //   console.log('receivedData?.slug',receivedData?.slug)
  //   const name = receivedData?.slug
  
  //   if (name === 'invoice') {
  //     return require("../../assets/images/shelly.png");
  //   }
  //   if (name === 'moad-so') {
  //     return require("../../assets/images/debby.png");
  //   }
  //   if (name === 'moad-w2') {
  //     return require("../../assets/images/cindy.png");
  //   }
  //   if (name === 'moad-pay-stub') {
  //     return require("../../assets/images/raisa.png");
  //   }
    
  //   return require("../../assets/images/alby.png"); // Default fallback image
  // };


  const buttons = [
    { label: "Input", value: "Input" },
    { label: "Fields", value: "Fields" },
    { label: "Output", value: "Output" },
    { label: "Review", value: "Review" },
  ];
  const footerRender = () => (
    <Box className="footer-buttons">
      <Button
        onClick={() => {
          const currentIndex = buttons.findIndex(
            (btn) => btn.value === selected
          );
          if (currentIndex > 0) {
            const nextIndex = (currentIndex - 1) % buttons.length; // Move to the next step
            handleButtonClick(buttons[nextIndex].value); // Set the next selected menu
          }
        }}
        variant="outlined"
        className="footer-back-button"
        startIcon={<ArrowBack />}
      >
        Back
      </Button>

      {selected === "Review" ? null : (
        <Button
          onClick={() => {
            if (selected === "Output") {
              setAgenNamePopUp(true);
            }
            else if(selected === 'Fields'){
              if(receivedData?.steps){
                     handleUpdateDetails()
              }else{
                console.log('formDetails?.system_instruction',formDetails?.system_instruction)
                const newErrors = {
                  system_instruction: formDetails?.system_instruction?.trim() === "" || !formDetails?.system_instruction ? "System instruction is required" : "",
                  output_instruction: formDetails?.output_instruction?.trim() === "" ||  !formDetails?.output_instruction ? "Output instruction is required" : "",
                };
            
                setErrors(newErrors);
            
                const hasErrors = Object.values(newErrors).some((error) => error !== "");
                if (!hasErrors) {
                  const currentIndex = buttons.findIndex(
                    (btn) => btn.value === selected
                  );
                  const nextIndex = (currentIndex + 1) % buttons.length; // Move to the next step
                  handleButtonClick(buttons[nextIndex].value); // Set the next selected menu
                }
              }
   
            }
            else {
              const currentIndex = buttons.findIndex(
                (btn) => btn.value === selected
              );
              const nextIndex = (currentIndex + 1) % buttons.length; // Move to the next step
              handleButtonClick(buttons[nextIndex].value); // Set the next selected menu
            }
          }}
          variant="outlined"
          className="footer-save-button"
          endIcon={receivedData?.steps?null:<ArrowForward />}
        >
          {createAgentLoading ? (
            <CircularProgress size={24} sx={{ color: "#fff" }} />
          ) : (
            <Typography className="save-text">
              {selected === "Review"
                ? "Run"
                : selected === "Output"
                ? "Next"
                :receivedData?.steps?'Update': "Next"}
            </Typography>
          )}
        </Button>
      )}
    </Box>
  );
  return (
    <AppLayout>
      <div   ref={parentRef} className="overview-menu-container">
        <Box className="header-section">
          <ArrowBack
            onClick={() => navigate("/agentSelection")}
            className="back-icon"
          />
          <h2 className="header-title">Back</h2>
        </Box>

        <div className="menu-button-section">
          <OverviewMenuButtons
            buttons={buttons}
            selected={selected}
            onButtonClick={handleButtonClick}
            containerStyles={{
              width: "535px",
              height: "22px",
            }}
            buttonStyles={{
              fontSize: "1rem",
              height: "50px",
              width: "90%",
            }}
          />

          <Button
            onClick={() => {
              selected === "Review"
                ? handleDialogOpen()
                : "Output" && setAgenNamePopUp(true);
            }}
            type="submit"
            disabled={selected === "Input" || selected === "Fields"}
            variant="contained"
            sx={{
              borderRadius: "25px", // Updated border radius
              width: "10%",
              backgroundColor: "#3B5CFF",
              marginRight: 20,
            }}
          >
            {createAgentLoading ? (
              <CircularProgress size={24} sx={{ color: "#fff" }} />
            ) : (
              <Typography className="save-text">
                {selected === "Review" ? "RUN" : "Next"}
              </Typography>
            )}
          </Button>
        </div>

        <BlueTile
          title={`${receivedData?.name}\n`}
          subtitle={`${receivedData?.name} Agent\n${receivedData?.name}@docketry.ai\nStatus: Sandbox`}
          imageSrc={
            getImages(receivedData?.slug)
          }
          containerStyles={{
            width: "550px",
            marginTop: "30px",
            height: "165px",
            backgroundColor: receivedData?.name === "Policy" && "#2AD899",
          }}
          imageStyles={{
            width: "80px",
          }}
        />
        {selected === "Review" && (
          <div
            style={{
              position: "absolute",
              right: 30,
              top: "29%",
              width: "50%",
            }}
          >
            {" "}
           {receivedData?.slug !=='moad-so' || receivedData?.slug !=='extract-iq' ? <OutputReview />:<CsvReviewScreen/>} 
          </div>
        )}
{selected === "Fields" && (
          <div
            style={{
              position: "absolute",
              right: 5,
              top: "20%",
              width: "50%",
            }}
          >
        
            <Prompts error={error} setErrors={setErrors} parentRef={parentRef} />
          </div>
        )}
        <div className="form-section">
          {selected === "Input" && <InputDirectoryForm />}
          {selected === "Fields" && (
            <FieldsDirectoryScreen  slug={receivedData?.slug} />
          )}
          {selected === "Output" && <OutPutDirectory />}
          {selected === "Review" && <ReviewScreen slug={receivedData?.slug} />}
        </div>

        {footerRender()}
      </div>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
      <DeployAIBot open={dialogOpen} onClose={handleDialogClose} />
      <AgenName open={AgenNamePopUp} onClose={()=>setAgenNamePopUp(false)} onclick={handleCreateAgent} />
    </AppLayout>
  );
};

export default OverviewMenuButtonsWithBorder;
